import { Outlet } from "react-router-dom";

const InfrastructureDasboard = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default InfrastructureDasboard;